import React, {useEffect, useState} from 'react'
import PageHeader from '../../../components/common/PageHeader'
import { getUserInfo } from '../../../utils/token';
import CustomerDynamicTable from '../../../components/common/CustomerDynamicTable';
import SubscriptionWidget from '../../../components/common/SubscriptionWidget';
import { getBatch, getBatchDetails } from '../../../api/endpoints/batch';
import { useNavigate, useParams } from 'react-router-dom';
import Excel from '../../../components/utils/Excel';

const BatchDetailsList = () => {
  const { batchId: paramsBatchId } = useParams(); // 'id' from /:id/customer/list
  const [companyId, setCompanyId] = useState(null);
  const [customerId, setCustomerId] = useState([]);
  const [listData, setListData] = useState([]);


  const processStatus = ["Pending", "Completed", "Error", "Cancelled"];
  useEffect(()=>{
    async function fetchData() {
      const {compId, userId} = getUserInfo();
      setCompanyId(compId);
      setCustomerId(userId);

      await getBatchDetails(paramsBatchId).then((res) => setListData(res.data.data));

    }
    fetchData();  
  },[]);

  const headerColumns = [
    
    { header: "Mobile", accessor: "mobile"},
    { header: "Delay", 
      accessor: "delay",
      render: (value) => (
        Number(value)/1000 + " sec"
      ),

    },
    {
      header: "status",
      accessor: "is_processed",
      render: (value) => (
        <span className={`badge ${value === 1 ? "bg-success" : "bg-danger"}`}>
          {processStatus[value]}
        </span>
      ),
    },
  ];

  return (
    <>
      <PageHeader  title="Batch Details List" breadcrumbs={[ {label: 'Customer'}, {label: 'Batch List'}, {label: 'Batch Details'}]}/>
      <SubscriptionWidget 
          compId ={companyId}
          customerId = {customerId}
        />
        <Excel batchId={paramsBatchId}/>
        <CustomerDynamicTable 
          data={listData}
          columns={headerColumns}
          actions={false}
        />
    </>
    
  )
}

export default BatchDetailsList